// extracted by mini-css-extract-plugin
module.exports = {"carouselItem":"CarouselItem_carouselItem___IpBu","carouselItemInner":"CarouselItem_carouselItemInner__IP_5I"};